import { render, staticRenderFns } from "./UsersLists.vue?vue&type=template&id=04755502&"
import script from "./UsersLists.vue?vue&type=script&lang=js&"
export * from "./UsersLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports